import classNames from 'classnames';
import styles from './ScommesseTableTabs.module.scss';
import { useTranslation } from 'hooks/useLingUI';
import { ScommesseTableTabsProps } from '.';

export const ScommesseTableTabs = ({
  descriptions,
  activeIndex,
  className,
  onSelectedItem,
}: ScommesseTableTabsProps) => {
  const { t } = useTranslation();

  const onItemClickHandler = (index: number) => {
    if (typeof onSelectedItem === 'function') {
      onSelectedItem(index);
    }
  };

  if (descriptions?.length > 1) {
    return (
      <div className={classNames(styles.container, className ?? '')} suppressHydrationWarning>
        <ul className={styles.list} suppressHydrationWarning>
          {descriptions?.map(({ descrizione, descrizioneTrKey, description }, index: number) => {
            return (
              <li
                key={`${descrizione}_${index}`}
                className={classNames(styles.item, { [styles.active]: activeIndex === index })}
                suppressHydrationWarning
              >
                <button
                  type="button"
                  className={styles.button}
                  suppressHydrationWarning
                  onClick={() => {
                    onItemClickHandler(index);
                  }}
                >
                  {t(descrizioneTrKey, descrizione ?? description)}
                </button>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }

  return null;
};
